import { toast } from "sonner";

import type { TabRefund } from "../../types";

/**
 * HA-983 — what the till says after a Pay Tab refund (or its retry): what happened, not "Payment refunded" whatever it was. Only a refund
 * that Succeeded is refunded; one Stripe is still making is processing, and one it did not make failed, with its reason.
 */
export function announceTabRefund(refund: TabRefund | null) {
	switch (refund?.status) {
		case "Succeeded":
			toast.success("Payment refunded");
			break;
		case "Pending":
			toast.success("Card refund sent");
			break;
		case "Processing":
			toast.info("Card refund processing", {
				description:
					"Stripe is making it. The payment shows it as processing until it settles.",
			});
			break;
		case "Failed":
			toast.error("The card refund failed", {
				description: refund.errorMessage ?? undefined,
			});
			break;
		default:
			toast.info("The refund was recorded");
	}
}
